import React, { useEffect, useState } from "react";
import ImportExportImg from "@assets/images/uniqueexporters&importers.svg";
import { tabHeadingDictionary as tabKeywords, redirectionCompanyTypeDictionary as redirectionCompanyTypeEnum, timeFrameOptions, requestObjectTypeDictionary } from "@core/global/global-country-dictionary";
import Select from "react-select";
import { Card, Form } from "react-bootstrap";
import TabHeader from "@shared/country-components/tabHeader";
import ReactTooltip from "react-tooltip";
import ReactTableTrademo from "@shared/trademo-datatable/react-table-trademo";
import { TrendsData } from "@shared/unique-importer-exporter-trends";
import { ChevronLeft, ChevronRight } from "react-feather";
import ImporterExporterGraph from "@shared/country-components/importer-exporter-graph";
import { searchTypeCustomStyles } from "@utils/utils";
import Filters from "../components/InternalFilter/filter";
import trackingEventDictionary from "@core/dictionary/tracking-event";
import UpgradeIcon from "@assets/images/Solid_Status_Lightning-alt.svg";
import { secondLevelRowsDropdown } from "@utils/enum";
import DataTable from "react-data-table-component";
import AscSortIcon from "@assets/images/AscSortIcon";
import DescSortIcon from "@assets/images/DescSortIcon";
import DemoTouchPoint from "@routes/intel/onboarding-screens/onboarding/VideoOpenerStrip";
import DynamicDropdown from "@components/base/DynamicDropDown/DynamicDropDown";
import { Tooltip as ReactTooltip5 } from "react-tooltip5";

const Importer = (props) => {
  useEffect(() => {
    let val = document.querySelectorAll(".lvl-two-table-container-left .rdt_Pagination select option");
    if (!!val && !!val.length) {
      val[0].textContent = 5;
      val[1].textContent = 10;
      val[2].textContent = 20;
    }
    let range = document.querySelectorAll(".lvl-two-table-container-left .rdt_Pagination span");
    if (!!range && !!range.length) {
      let toPage = (props.defaultPage * props.importerPerPage) / props.secondLevelRowDropdownValue.value - 1;
      let fromPage = toPage - props.importerPerPage / props.secondLevelRowDropdownValue.value + 1;
      range[1].textContent = props.totalUniqueImporter >= 5 ? `${fromPage + 1} - ${toPage + 1 > props.totalUniqueImporter ? props.totalUniqueImporter : toPage + 1} of ${props.totalUniqueImporter}` : `${fromPage + 1} - ${props.totalUniqueImporter} of ${props.totalUniqueImporter}`;
    }
    let prevPage = document.querySelectorAll(".lvl-two-table-container-left .rdt_Pagination #pagination-previous-page");
    if (!!prevPage && !!prevPage.length && props.defaultPage > 1) {
      prevPage[0].removeAttribute("disabled");
    }
    let totalPages = Math.floor(props.totalUniqueImporter / (props.importerPerPage / props.secondLevelRowDropdownValue.value)) + 1;
    let nextPage = document.getElementById("pagination-next-page");

    if (nextPage) {
      if (props.defaultPage >= totalPages) {
        nextPage.setAttribute("disabled", true);
        nextPage.style.opacity = "0.4";
        nextPage.style.cursor = "not-allowed";
      } else {
        nextPage.removeAttribute("disabled");
      }
    }
  });
  const customStyles = {
    rows: {
      style: {
        minHeight: "62px",
        maxHeight: "fit-content !important",
        zIndex: 0,
        "&:nth-child(n+0)": {
          borderBottom: "none !important",
        },
      },
    },
    headCells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "8px",
        borderRight: "1px solid #eaecf0",
        "&:nth-child(1)": {
          backgroundColor: "white",
          position: "sticky",
          zIndex: 2,
          left: 0,
          minWidth: "285px",
        },
        "&:nth-child(2)": {
          backgroundColor: "white",
          position: "sticky",
          zIndex: 2,
          left: "285px",
        },
        "&:nth-child(n+2)": {
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
          backgroundColor: "white",
          minWidth: "160px !important",
        },
      },
    },
    cells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "8px",
        borderRight: "1px solid #eaecf0",
        "&:nth-child(1)": {
          borderBottom: "1px solid #eaecf0",
          backgroundColor: "white",
          position: "sticky",
          zIndex: 2,
          left: 0,
          minWidth: "285px",
        },
        "&:nth-child(2)": {
          borderBottom: "1px solid #eaecf0",
          backgroundColor: "white",
          position: "sticky",
          zIndex: 2,
          left: "285px",
        },
        "&:nth-child(n+2)": {
          display: "flex",
          borderBottom: "1px solid #eaecf0",
          backgroundColor: "white",
          justifyContent: "start",
          alignItems: "center",
          minWidth: "160px !important",
        },
      },
    },
  };

  const [activeDropdown, setActiveDropdown] = useState(null);
  const toggle = (name) => setActiveDropdown(activeDropdown === name ? null : name);
  const close = () => setActiveDropdown(null);

  const fromDate = new Date(props.existingSearchReqObj.fromDate);
  const toDate = new Date(props.existingSearchReqObj.toDate);
  const diffInMs = toDate - fromDate;
  const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
  const isWithinOneYear = diffInDays <= 730;

  return (
    <div>
      <div className={props.currentTab === tabKeywords.importers ? "tab-pane fade show active" : "tab-pane fade"} id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
        <div className="trademo-table-container">
          {!!props.currentUserPlan && props.currentUserPlan !== "" && !!props.currentPlanAccess && props.currentPlanAccess.consignee_shipper === false ? (
            <Card className="upgrade-card">
              <Card.Body>
                <div className="container">
                  <div className="row">
                    <div className="col-auto">
                      <div>
                        <img src={UpgradeIcon} alt="..." className="img-fluid" />
                      </div>
                    </div>
                    <div className="col">
                      <p>This feature enables you to view list of unique consignee across the searched shipments with standardised names and after exclusion of logisitic companies</p>
                      <p>Upgrade to higher Pro or Advanced plan to use this feature</p>
                      <div className="d-block my-3">
                        <button type="button" className="btn btn-success tw-bg-secondary-green" onClick={(e) => props.upgradeNow(e)}>
                          Upgrade
                        </button>
                      </div>
                      <div className="d-block">
                        <img src={ImportExportImg} alt="..." className="img-fluid" />
                      </div>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          ) : (
            <div className="tw-flex tw-flex-col">
              <div className="tw-flex tw-flex-col tw-gap-4 tw-py-4">
                <div className="tw-flex tw-w-full tw-justify-start tw-h-9">
                  {!!props.showUiTrends && props.showUiTrends === true ? (
                    <div className="col-md-4 d-flex tw-px-0">
                      <div className="tw-flex tw-border tw-border-gray-200 tw-rounded-lg">
                        <span className={`cursor-pointer tw-text-sm tw-text-gray-900 tw-font-medium tw-py-2 tw-px-4  ${props.trendsTab === false && props.isImporterTableVisible === true ? "tw-bg-gray-200 tw-font-semibold tw-rounded-l" : "non-selected"}`} onClick={() => props.setTrendsTableToggle(false)}>
                          Rank
                        </span>
                        {!!props.isRedirect === true && props.isRedirect === true && props.redirectingCompanyType === redirectionCompanyTypeEnum.exporter.value && props.defaultData.isImpExpGraph ? (
                          <span className={`cursor-pointer tw-text-sm tw-text-gray-900 tw-font-medium tw-py-2 tw-px-4 ${props.isImporterTableVisible === false && props.trendsTab === false ? "tw-bg-gray-200 tw-font-semibold" : "non-selected"}`} onClick={() => props.setExporterTableToggle(false)}>
                            Network
                          </span>
                        ) : (
                          ""
                        )}
                        <span
                          className={`cursor-pointer tw-text-sm tw-text-gray-900 tw-font-medium tw-py-2 tw-px-4 ${props.trendsTab === true ? "tw-bg-gray-200 tw-font-semibold tw-rounded-r" : "non-selected"}`}
                          onClick={() => {
                            props.setTrendsTableToggle(true);
                          }}>
                          Trends
                        </span>
                      </div>
                      {props.isImporterTableVisible !== false && props.trendsTab ? (
                        <div className="sort-dropdown d-flex ml-2 modifying-styling">
                          <div className="custom-dropdown d-flex justify-content-center align-items-center">
                            <Select
                              isSearchable={false}
                              options={timeFrameOptions}
                              defaultValue={props.currentTimeFrame}
                              styles={searchTypeCustomStyles}
                              onChange={(e) => {
                                if (e && e.value && e.value === "year") {
                                  props.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabTrendsYoY);
                                } else if (e && e.value && e.value === "month") {
                                  props.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabTrendsMoM);
                                } else if (e && e.value && e.value === "quarter") {
                                  props.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabTrendsQoQ);
                                }
                                props.changeUniqueImporterDuration(e);
                              }}
                              className="match-type my-auto mx-0 w-100 tw-z-[3]"
                              autosize={true}
                            />
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                  {props.isImporterTableVisible === false || props.trendsTab === true || props.defaultData.showUiUeLevelTwo ? (
                    <div className="col-md-4 d-flex justify-content-center tw-px-0">
                      {props.defaultData.showUiUeLevelTwo && !(props.isImporterTableVisible === false && props.trendsTab === false) && !props.isMerged ? (
                        <div id="second-level-toggle" className="d-flex align-items-center justify-content-end ml-2">
                          <span className="mr-1 two_level_label">Enable 2nd Level Hierarchy</span>
                          <span className={props.defaultData.showUiUeLevelTwo && props.uiTwoLevel ? "twolevel-checkbox" : "twolevel-checkbox-uncheck"}>
                            <Form.Check
                              type="switch"
                              id="custom-switch-1"
                              checked={props.uiTwoLevel}
                              className={props.totalUniqueImporter > 5000 && props.isIntFilterApplied ? "tw-cursor-not-allowed" : ""}
                              onChange={(e) => {
                                // if (props.totalUniqueImporter > 5000 && props.isIntFilterApplied) {
                                //   toast.error("2nd level analytics is not available for more than 5000 companies if company level filters are applied.");
                                //   return;
                                // }
                                if (props.trendsTab && e.target.checked) {
                                  props.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabTrends2ndLevelAnalytics);
                                } else if (e.target.checked) {
                                  props.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabRank2ndLevelAnalytics);
                                }
                                props.changeUITwoLevelHandler(e);
                              }}
                            />
                          </span>
                        </div>
                      ) : null}
                    </div>
                  ) : (
                    <></>
                  )}
                  <div className="tw-w-full tw-flex tw-justify-end">
                    <DemoTouchPoint module="finding_better_prospects_shipments_page_importers_tab" />
                  </div>
                </div>
                <div className="tw-w-full">
                  <div className="tw-flex tw-justify-between">
                    <TabHeader
                      addToFaV={props.addToFaV}
                      setAddToFav={(val) => props.setAddtoFav(val)}
                      getUserPlan={() => props.getUserPlanHandler()}
                      applyUIUEFilterHandler={props.applyUIUEFilterHandler}
                      prospectData={props.prospectImporter}
                      type="Importer"
                      userFirstPlan={props.userFirstPlan}
                      selectedData={props.selectedImporterRowData}
                      upgradePlansDictionary={props.upgradePlansDictionary}
                      userCredit={props.userCredit}
                      creditQuota={props.creditQuota}
                      totalDataCount={props.totalUniqueImporter}
                      defaultData={props.defaultData}
                      onDownload={(type, downloadFromValue, downloadToValue, closeDownloadFromModal) => props.downloadImpExpConfirm(type, downloadFromValue, downloadToValue, closeDownloadFromModal)}
                      onSelect={(closeDownloadFromModal) => props.mappingUniqueImporterExporter("XLS", "Importer", closeDownloadFromModal)}
                      tradeDirection={props.defaultData.countryType}
                      dataSource={props.defaultData.country_small}
                      isSalesForceRedirection={props.isSalesForceRedirection}
                      currentUserPlan={props.currentUserPlan}
                      pathname={window.location.pathname}
                      showBolFilter={props.showBolFilter}
                      analyticsCountryID={props.defaultData.analyticsCountryID}
                      isRedirect={props.isRedirect}
                      redirectingCompanyExporterId={props.redirectingCompanyExporterId}
                      redirectingCompanyImporterId={props.redirectingCompanyImporterId}
                      clearButton={() => props.clearButton}
                      trendsTab={props.trendsTab || props.exporterTrendsTab}
                      onClear={() => props.toggleClearButton("importers")}
                      isTwoLevel={props.uiTwoLevel}
                      isMerged={props.isMerged}
                      redirectionCompanyType={props.redirectionCompanyType}
                      allFilters={props.filterMapList}
                      emptyFilterObj={props.emptyFilterObj}
                      fromAccutalArrivalDate={props?.fromAccutalArrivalDate}
                      toAccutalArrivalDate={props?.toAccutalArrivalDate}
                      finalReqObj={props.finalReqObj}
                      currentTab={props.currentTab}
                      source="importer_exporter"
                    />
                    <div className="d-flex justify-content-end tw-gap-2 tw-px-0">
                      {(props.uiTwoLevel && !props.trendsTab) || props.trendsTab ? (
                        <div className="sort-dropdown d-flex tw-justify-end">
                          <DynamicDropdown
                            isOpen={activeDropdown === "sort"}
                            dropdownValue={activeDropdown}
                            onToggle={() => toggle("sort")}
                            onClose={close}
                            buttonLabel={`Analyse By: ${props.selectSortDefaltValueHandler(props.importerSortValue).label}`}
                            options={props.importer_exporter_graph_sort__options}
                            onSelect={(item) => {
                              props.handleImporterSorting("importer", { selector: item.value }, props.importerSortOrderValue);
                              close();
                            }}
                            buttonId="sort-dropdown"
                            icon={{ after: false, before: true, onClose: "swap_vert", onOpen: "swap_vert" }}
                            dropdownClassName="!tw-w-full"
                          />
                        </div>
                      ) : null}
                      {((!!props.appliedStateFilterObject && props.checkforFilters(props.appliedStateFilterObject)) || (props.isSearchButtonCalled === true && props.searchedItem !== "")) && props.prospectImporter.length === 0 && props.currentPlanAccess && props.currentPlanAccess.is_internal_filter !== false && isWithinOneYear ? (
                        <Filters
                          clearFilter={() => {
                            props.clearFilter();
                          }}
                          sendingDataToSearch={(data) => props.gettingDataFromUIEFilter(data)}
                          type="IMPORTER"
                          callingPendoEvent={(event) => props.checkPendoEventForCompanyRedirection(event)}
                          currentUserPlan={props.currentUserPlan}
                          sendingAllData={(data) => props.gettingAllData(data)}
                          importerData={props.importerTab}
                          internalFilterList={props.defaultData.internalFilterList}
                        />
                      ) : (
                        <></>
                      )}
                      {props.uiTwoLevel && (
                        <DynamicDropdown
                          isOpen={activeDropdown === "secondLevel"}
                          dropdownValue={activeDropdown}
                          onToggle={() => toggle("secondLevel")}
                          onClose={close}
                          buttonLabel={`No. of 2nd Level Entities : ${props.secondLevelRowDropdownValue.label}`}
                          options={secondLevelRowsDropdown}
                          onSelect={(item) => {
                            props.onSecondLevelImporterRowDropdownChange(item);
                            close();
                          }}
                          dropdownClassName="!tw-w-full"
                          icon={{ after: true, before: false, onClose: "keyboard_arrow_down", onOpen: "keyboard_arrow_up" }}
                          buttonId="second-level-dropdown"
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {(props.isImporterTableVisible === true || !props.defaultData.isImpExpGraph) && props.trendsTab === false ? (
                <div className={`${props.defaultData.showUiUeLevelTwo && props.uiTwoLevel ? "lvl-two-table-container lvl-two-i-e-l lvl-two-common-table " : ""} tw-border tw-rounded-lg`}>
                  <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" />
                  {props.isUIGridNew && props.isUIGridNew === true && !props.uiTwoLevel ? (
                    <>
                      <ReactTableTrademo
                        columns={props.importerTableColumn}
                        data={props.defaultTrendsData}
                        paginationTotalRows={props.totalUniqueImporter}
                        onSelectedRowsChange={(selectedRows) => {
                          props.selectedImporterRowFunClone(selectedRows);
                        }}
                        //to enable 'asc' sorting only replace first 'desc' with 'asc'
                        onSort={(e) => props.handleImporterSortingClone(e, props.importerSortOrderValue === "desc" ? "desc" : "desc")}
                        defaultSortField={props.defaultData.sortKeyUniqueImpExpMap[props.importerSortValue] ? props.defaultData.sortKeyUniqueImpExpMap[props.importerSortValue] : props.importerDefaultSortValue ? props.importerDefaultSortValue.columnKey : "date"}
                        defaultSortAsc={props.importerSortOrderValue === "desc" ? false : true}
                        paginationPerPage={props.importerPerPage}
                        onChangeRowsPerPage={props.handleSearchPerRowsImporterChangeClone}
                        onTableObjectChange={props.updateTrademoUITableObjectClone}
                        onChangePage={props.handlePerRowsChangeImporterClone}
                        paginationDefaultPage={props.importerCurrentPage}
                        noDataComponent={props.isLoaderActive === true || props.isDownloadLoaderActive === true || props.isTrendsActive ? "" : "No Unique Importer Found"}
                        clearSelectedRows={props.importerToggleRows}
                        selectedData={props.selectedImporterRowData}
                        shipmentDefaultSortValue={props.defaultData.importerSorting}
                        sortOrderValue={props.importerSortOrderValue}
                        hideSorting={true}
                        fixSelection="start"
                        options={[25, 50, 100]}
                        blockAscSorting={true}
                      />
                      <ReactTooltip5 className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="right" id={`address-tooltip`} />
                    </>
                  ) : props?.secondLevelData?.length ? (
                    //this is rank 2nd level table
                    <div className="lvl-two-table-container-left">
                      <DataTable
                        title="Data3"
                        columns={props.importerTableColumn}
                        className="!tw-min-h-[408px]"
                        data={!!props.defaultTrendsData && props.defaultTrendsData.length !== 0 && props.uiTwoLevel === false ? props.defaultTrendsData : props?.secondLevelData?.length ? props.secondLevelData : []}
                        paginationTotalRows={props.totalUniqueImporter}
                        paginationRowsPerPageOptions={[props.secondLevelRowDropdownValue.value * 5, props.secondLevelRowDropdownValue.value * 10, props.secondLevelRowDropdownValue.value * 20]}
                        customStyles={customStyles}
                        onSort={(e) => props.handleImporterSorting("importer", e, props.importerSortOrderValue === "desc" ? "desc" : "desc")}
                        paginationPerPage={props.importerPerPage}
                        onChangeRowsPerPage={props.handleSearchPerRowsImporterChange}
                        onChangePage={() => null}
                        paginationDefaultPage={props.importerCurrentPage}
                        sortIcon={props.importerSortOrderValue === "desc" ? <AscSortIcon height={"16px"} width={"16px"} color={"#101828"} /> : <DescSortIcon height={"16px"} width={"16px"} color={"#101828"} />}
                        pagination
                        highlightOnHover={false}
                        persistTableHead
                        sortServer={true}
                        paginationIconPrevious={
                          <ChevronLeft
                            color={props.defaultPage > 1 ? "rgba(0,0,0,0.54)" : "#D1D1D1"}
                            onClick={() => {
                              props.prevSecondLevelHandler();
                            }}
                          />
                        }
                        paginationIconNext={
                          <ChevronRight
                            color={"rgba(0,0,0,0.54)"}
                            onClick={() => {
                              props.nextSecondLevelHandler();
                            }}
                          />
                        }
                      />
                      <ReactTooltip5 className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="right" id={`address-tooltip`} />
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              ) : props.trendsTab === true ? (
                <div>
                  <TrendsData
                    isTrendsTab={props.currentTab === tabKeywords.importers ? props.trendsTab : props.exporterTrendsTab}
                    isTwoLevel={props.currentTab === tabKeywords.importers ? props.uiTwoLevel : props.ueTwoLevel}
                    dynamicTrendsData={props.dynamicTrendsData}
                    handleChangePerPage={(e) => {
                      props.UIHandlerPerPage(e);
                    }}
                    showPopup={props.showPopup}
                    defaultSortField={props.defaultData.sortKeyUniqueImpExpMap[props.importerSortValue] ? props.defaultData.sortKeyUniqueImpExpMap[props.importerSortValue] : props.importerDefaultSortValue ? props.importerDefaultSortValue.columnKey : "date"}
                    setShowPopup={(val) => props.setShowPopUp(val)}
                    applyUIUEFilterHandler={props.applyUIUEFilterHandler}
                    filterObj={props.filterObj}
                    currentUserPlan={props.currentUserPlan}
                    pathname={window.location.pathname}
                    analyticsCountryID={props.defaultData.analyticsCountryID}
                    analyticsTrends_mustnot_Data={props.analyticsTrends_mustnot_Data}
                    defaultTrendsData={!!props.defaultTrendsData && props?.defaultTrendsData?.length !== 0 && props.uiTwoLevel === false ? props.defaultTrendsData : props?.secondLevelData?.length ? props.secondLevelData : []}
                    paginationDefaultPage={props.importerCurrentPage}
                    clearButton={props.clearButtonState}
                    selectedRows={props.prospectImporter}
                    paginationTotalRows={props.totalUniqueImporter}
                    totalCompanyCount={props.totalUniqueImporter}
                    isNewShow={props.isUIGridNew}
                    onSelectedRowsChange={(selectedRows) => props.selectedImporterRowFunClone(selectedRows)}
                    onTableObjectChange={props.updateTrademoUITableObjectClone}
                    selectedData={props.selectedImporterRowData}
                    shipmentDefaultSortValue={props.defaultData.importerSorting}
                    sortType={props.importerSortValue}
                    currentTab={props.currentTab}
                    requestObj={props.existingSearchReqObj}
                    currentKeyViewTrendItem={props.finalReqObj}
                    timeFrame={props.currentTimeFrame}
                    clearSelectedRows={props.importerToggleRows}
                    viewTrends={() => props.getUniqueImporterData(requestObjectTypeDictionary.importers, "pagination")}
                    handleTrendsSorting={(data1, data2) => props.handleTrendsSorting(data1, data2)}
                    defaultSortAsc={props.importerSortOrderValue === "desc" ? false : true}
                    paginationPerPage={props.importerPerPage}
                    onChangeRowsPerPage={props.handleSearchPerRowsImporterChangeClone}
                    defaultSort={props.impDefaultSort}
                    onChangePage={props.handlePerRowsChangeImporter}
                    currentPlanAccess={props.currentPlanAccess}
                    isLoaderActive={props.isLoaderActive || props.isDownloadLoaderActive === true || props.isTrendsActive}
                    selectSortDefaltValueHandler={props.selectSortDefaltValueHandler(props.importerSortValue)}
                    isSalesForceRedirection={props.isSalesForceRedirection}
                    defaultData={props.defaultData}
                    isRedirect={props.isRedirect}
                    redirectingCompanyExporterId={props.redirectingCompanyExporterId}
                    redirectingCompanyImporterId={props.redirectingCompanyImporterId}
                    twoColumnMapping={props.defaultData.twoColumnMapping}
                    defaultUiUeTwoLevelSelctedHeading={props.defaultUiUeTwoLevelSelctedHeading}
                    selectedUiUeTwoLevelHeading={(data) => props.selectedUiUeTwoLevelHeading(data)}
                    showTwoLevel={props.uiTwoLevel}
                    viewAllPerPage={props.importerPerPage}
                    defaultPage={props.defaultPage}
                    viewTrendsFinalSearchReqObj={props.finalReqObj}
                    updatingMustNot={(data) => {
                      props.updatingMustNot(data);
                    }}
                    isGridNew={props.isUIGridNew}
                    fixedLengthUpto={props.fixedLengthUptoTrend}
                    resetSecondLevel={() => props.resetSecondLevel}
                    trendsTab={props.trendsTab}
                    handleIESorting={props.importerSortValue}
                    secondLevelRowDropdownValue={props.secondLevelRowDropdownValue.value}
                    sortOrderValue={props.importerSortOrderValue}
                    paginationIconPrevious={
                      <ChevronLeft
                        color={props.defaultPage > 1 ? "rgba(0,0,0,0.54)" : "#D1D1D1"}
                        onClick={() => {
                          props.prevSecondLevelHandler();
                        }}
                      />
                    }
                    paginationIconNext={
                      <ChevronRight
                        color={"rgba(0,0,0,0.54)"}
                        onClick={() => {
                          props.nextSecondLevelHandler();
                        }}
                      />
                    }
                  />
                </div>
              ) : props.currentTab === tabKeywords.importers && props.isLoaderActive === false && props.existingUniqueImpExpReqObj.toDate && props.redirectingCompanyImporterId !== "" && !!props.defaultData.isImpExpGraph ? (
                <div>
                  <div className="hr mt-2 mb-3" />
                  <ImporterExporterGraph
                    companyName={props.redirectingCompanyName}
                    type="IMPORTER"
                    totalCount={props.totalUniqueImporter}
                    searchReqObj={props.existingUniqueImpExpReqObj}
                    isInternalFilterApplied={(!!props.uniqueImportExporterShipment && props.uniqueImportExporterShipment.length > 0) || (!!props.uniqueImportExporterWeight && props.uniqueImportExporterWeight.length > 0) || (!!props.uniqueImportExporterTeu && props.uniqueImportExporterTeu.length > 0) || (!!props.uniqueImportExporterValue && props.uniqueImportExporterValue.length > 0) ? true : false}
                    uniqueImportExporterShipment={!!props.uniqueImportExporterShipment && props.uniqueImportExporterShipment.length > 0 ? props.uniqueImportExporterShipment : ""}
                    uniqueImportExporterWeight={!!props.uniqueImportExporterWeight && props.uniqueImportExporterWeight.length > 0 ? props.uniqueImportExporterWeight : ""}
                    uniqueImportExporterTeu={!!props.uniqueImportExporterTeu && props.uniqueImportExporterTeu.length > 0 ? props.uniqueImportExporterTeu : ""}
                    uniqueImportExporterValue={!!props.uniqueImportExporterValue && props.uniqueImportExporterValue.length > 0 ? props.uniqueImportExporterValue : ""}
                    impExpGraphDataApi={props.defaultData.apiEndPoints.getImpExpGraphData}
                  />
                </div>
              ) : (
                <></>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(Importer);
